import addRoute from '@/router/add-route';

const Webhooks = () => import('@/modules/webhooks/webhooks.vue');
const WebhookForm = () => import('@/modules/webhooks/webhook-form.vue');

const webhooks = [
    addRoute({
        name: 'webhooks',
        path: '/webhooks',
        component: Webhooks,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'add-webhook',
        path: '/webhooks/add',
        component: WebhookForm,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'update-webhook',
        path: '/webhooks/update/:id/:continue?',
        component: WebhookForm,
        root: {label: 'Automations', name: 'automations'},
    }),
];

export default webhooks;
